module.exports = __webpack_public_path__ + "img/봉은사역 맛집 2.4827560b.png";